module.exports = __webpack_public_path__ + "img/new_yourorder.173a8c51.png";